"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var load_keycloak_1 = require("./load-keycloak");
var Keecloak = /** @class */ (function () {
    function Keecloak(options) {
        this._initialized = false;
        this._options = options;
    }
    Keecloak.prototype._createKeycloakInstance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var KC;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, load_keycloak_1.loadKeycloakFromServer(this._options.url)];
                    case 1:
                        KC = _a.sent();
                        this._keycloak = KC({
                            url: this._options.url,
                            realm: this._options.realm,
                            clientId: this._options.clientId
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Keecloak.prototype.init = function () {
        var _this = this;
        // Monkeypatching promise because keycloak-js is broken 🤮🤮🤮
        var pt = Promise.prototype;
        pt.success = function (a) { return this.then(a); };
        pt.error = function (a) { return this.catch(a); };
        if (this._initPromise)
            return this._initPromise;
        this._initPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
            var authenticated;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._createKeycloakInstance()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._keycloak.init(__assign(__assign({ onLoad: "check-sso", checkLoginIframe: false }, { promiseType: "native" }), (this._options.offline ? {
                                token: localStorage.getItem("o_t"),
                                idToken: localStorage.getItem("o_it"),
                                refreshToken: localStorage.getItem("o_rt")
                            } : {})))];
                    case 2:
                        authenticated = _a.sent();
                        this._initialized = true;
                        if (!authenticated) return [3 /*break*/, 4];
                        this._onTokenUpdateInternal();
                        return [4 /*yield*/, this._fetchUserInfo()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this._keycloak.onAuthLogout = this.onLogout;
                        setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                            var e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this._keycloak.authenticated &&
                                            this._keycloak.isTokenExpired(60))) return [3 /*break*/, 4];
                                        console.debug('Token about to expire. Refreshing...');
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, this._keycloak
                                                .updateToken(60)];
                                    case 2:
                                        _a.sent();
                                        this._onTokenUpdateInternal();
                                        return [3 /*break*/, 4];
                                    case 3:
                                        e_1 = _a.sent();
                                        if (this.onError) {
                                            this.onError(new Error("Unable to refresh token: " + e_1.message));
                                        }
                                        else {
                                            console.debug("Unable to refresh token: " + +e_1.message);
                                        }
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }, 1000);
                        return [2 /*return*/, authenticated];
                }
            });
        }); })();
        return this._initPromise;
    };
    Keecloak.prototype._fetchUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._keycloak.loadUserInfo()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Keecloak.prototype._onTokenUpdateInternal = function () {
        if (this.onTokenUpdate) {
            this.onTokenUpdate(this.token);
        }
        else {
            console.debug("Token was refreshed");
        }
        if (this._options.offline) {
            this.storeTokens();
        }
    };
    Keecloak.prototype.storeTokens = function () {
        localStorage.setItem("o_t", this._keycloak.token);
        localStorage.setItem("o_it", this._keycloak.idToken);
        localStorage.setItem("o_rt", this._keycloak.refreshToken);
    };
    Keecloak.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.authenticated)
                            return [2 /*return*/, Promise.resolve()];
                        if (!this._initialized)
                            throw new Error("Keycloak is not initialized");
                        return [4 /*yield*/, this._keycloak.login(__assign({}, (this._options.offline ? { scope: "offline_access" } : {})))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Keecloak.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._options.offline) {
                            localStorage.removeItem("o_t");
                            localStorage.removeItem("o_it");
                            localStorage.removeItem("o_rt");
                        }
                        return [4 /*yield*/, this._keycloak.logout()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Keecloak.prototype, "authenticated", {
        get: function () {
            return this._keycloak.authenticated;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Keecloak.prototype, "token", {
        get: function () {
            return this._keycloak.token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Keecloak.prototype, "userInfo", {
        get: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            if (!this.authenticated)
                return undefined;
            return __assign(__assign({}, this._keycloak.userInfo), { realm_access: (_a = this._keycloak) === null || _a === void 0 ? void 0 : _a.realmAccess, resource_access: (_b = this._keycloak) === null || _b === void 0 ? void 0 : _b.resourceAccess, roles: Object.keys(((_c = this._keycloak) === null || _c === void 0 ? void 0 : _c.resourceAccess) || {}).reduce(function (agg, key) {
                    var _a;
                    return (__assign(__assign({}, agg), (_a = {}, _a[key] = _this._keycloak.resourceAccess[key].roles, _a)));
                }, {
                    realm: (_f = (_e = (_d = this._keycloak) === null || _d === void 0 ? void 0 : _d.realmAccess) === null || _e === void 0 ? void 0 : _e.roles) !== null && _f !== void 0 ? _f : []
                }) });
        },
        enumerable: false,
        configurable: true
    });
    return Keecloak;
}());
exports.default = Keecloak;
